import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/ups': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M103.2 303v-123h32.6v141.6c-17.7 12.1-97.9 35.9-97.9-39v-102.6h32.7v104c0 32.1 27.4 22.6 32.6 19zM4 74.8c93.6-49.6 259.1-61.6 375.4 0v220.9c0 103.9-75.3 135.2-187.7 184.1-112.8-48.9-187.7-80.4-187.7-184.1v-220.9zM362.1 295.7v-216.2c-109.3-10.2-238.6-4-340.9 89.8v126.4c0 86.6 53 113.5 170.5 165.3 117.2-51.7 170.4-78.7 170.4-165.3zM152.5 188.3c23.7-15.3 104.4-31.8 104.4 65.6 0 75.9-47.3 85.8-71.7 78.5v68.7h-32.7v-212.8zM185.2 305.6c2 0.8 38.4 16.9 38.4-51 0-62-30-53.5-38.4-49.3v100.3zM264.3 219.2c-0.2-41.1 51.2-53.9 79.7-31.9v28.4c-17.9-18.3-47.9-18.1-48.5 2.2-0.7 26.6 55.1 21.7 53.4 73.2-1.3 41.6-47 55-83.2 33.5v-30.1c20.4 18.1 51.4 18.6 50.8-4.9-0.6-27.9-52.1-23.1-52.2-70.4z'
      }
    ]
  }
})
